module.exports = __webpack_public_path__ + "static/img/weitu.d05e95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/weitu.png
// module id = sGlB
// module chunks = 31